import { Alert, Box, Button, Dialog, Grow, Typography } from "@mui/material";
import ButtonMapMenuClose from "assets/icons/btn_mapmenu_close.svg";
import MenuAreaSelect from "assets/icons/ic_menu_areaselect.svg";
import { PrefectureAutocomplete } from "components/Parts/Atoms/PrefectureAutocomplete";
import React from "react";
import styles from "./SwitchAreaDialog.module.scss";
import { useSwitchAreaDialogHooks } from "./hooks";
import { SwitchAreaDialogProps } from "./interfaces";
import { CitiesSelector } from "./subComponents/CitiesSelector";

const idPrefix = "switch-area-dialog";

export const SwitchAreaDialog = React.memo((props: SwitchAreaDialogProps) => {
  const {
    titRef,
    boxRef,
    listboxRef,

    selectedPrefectures,
    prefecturesErrorMessage,
    citiesErrorMessage,
    selectableCities,
    selectedCityCodes,

    selectAllButtonOn,
    selectMyAreaButtonOn,
    okButtonOn,

    onPrefecturesChange,
    onCitiesClick,
    onResetButtonClick,
    onAllAreaButtonClick,
    onOkButtonClick,
    onClose,
    onBackPaperClick
  } = useSwitchAreaDialogHooks(props);

  return (
    <Dialog
      open={props.open}
      aria-labelledby={`${idPrefix}-title`}
      aria-describedby={`${idPrefix}-description`}
      onClose={(e, reason) =>
        reason !== "escapeKeyDown" && props.onClose && props.onClose()
      }
      slotProps={{
        paper: { onClick: onBackPaperClick },
        backdrop: { className: styles.backdrop }
      }}
      classes={{
        scrollPaper: styles.paperScrollPaper,
        paper: styles.paper,
        container: styles.container
      }}
      slots={{ transition: Grow }}
      transitionDuration={{ appear: 200, enter: 200, exit: 100 }}
    >
      <Box className={`${styles.popup_map} twbasic01 ${styles.on}`}>
        <Box className={styles.scroll}>
          <Box className={styles.tit} ref={titRef}>
            <Box component="span">
              <img src={MenuAreaSelect} alt="市区町村選択" />
            </Box>
          </Box>
          <Box className={styles.btn_sub_close} onClick={props.onClose}>
            <img src={ButtonMapMenuClose} alt="閉じる" />
            <Typography component="b">閉じる</Typography>
          </Box>
          <Box className={styles.box} ref={boxRef}>
            <Box className={styles.box2}>
              <Box className={styles.ovfl}>
                <Box className={styles.popup_map_areaselect}>
                  {props.isAdministrator ? (
                    <Box className={styles.ctt}>
                      <Box className={styles.ken}>
                        <PrefectureAutocomplete
                          multiple={true}
                          value={selectedPrefectures}
                          disableCloseOnSelect
                          slotProps={{ listbox: { ref: listboxRef } }}
                          onChange={onPrefecturesChange}
                          setFatal={props.setFatal}
                          errorMessage={prefecturesErrorMessage || ""}
                        />
                      </Box>
                    </Box>
                  ) : null}
                  <Box className={styles.ctt}>
                    <Box className={styles.dtl}>
                      <Box className={styles.other}>
                        {props.isAdministrator ? (
                          <Box
                            className={`${styles.btn_pum02} ${
                              styles.click_act01
                            } ${selectAllButtonOn ? styles.on : styles.off}`}
                            onClick={onAllAreaButtonClick}
                          >
                            全て選択
                          </Box>
                        ) : null}
                        <Box
                          className={`${styles.btn_pum02} ${
                            styles.click_act01
                          } ${selectMyAreaButtonOn ? styles.on : styles.off} ${
                            styles.tantou
                          }`}
                          onClick={onResetButtonClick}
                        >
                          担当市区町村のみ選択
                        </Box>
                      </Box>
                      <Box className={styles.area}>
                        <CitiesSelector
                          selectableCities={selectableCities}
                          selectedCityCodes={selectedCityCodes}
                          onCitiesClick={onCitiesClick}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box className={`${styles.popup_map_btn} ${styles.btn_2ko}`}>
              <Box className={styles.bottom}>
                {citiesErrorMessage ? (
                  <Alert className={styles.alert} color="error">
                    {citiesErrorMessage}
                  </Alert>
                ) : null}
                {props.forEstateList ? (
                  <>
                    <Button
                      variant="contained"
                      className={styles.cancelButton}
                      onClick={onClose}
                    >
                      キャンセル
                    </Button>
                    <Button
                      variant="contained"
                      className={styles.okButton}
                      disabled={!okButtonOn}
                      onClick={onOkButtonClick}
                    >
                      OK
                    </Button>
                  </>
                ) : (
                  <>
                    <Box
                      onClick={onClose}
                      className={`${styles.btn} ${styles.cancel}`}
                    >
                      閉じる
                    </Box>
                    <Box
                      onClick={onOkButtonClick}
                      className={`${styles.btn} ${styles.arrow} ${
                        okButtonOn ? styles.on : styles.off
                      }`}
                    >
                      切り替える
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
});
